import { useState, useEffect } from "react";
import { LocationConsentModal } from "@/components/LocationConsentModal";

export const useLocationConsent = () => {
  const [showModal, setShowModal] = useState(false);
  const [consentStatus, setConsentStatus] = useState<'granted' | 'denied' | 'pending'>('pending');

  useEffect(() => {
    // Check if user has already made a choice
    const savedConsent = localStorage.getItem('location_consent');
    
    if (savedConsent === 'granted') {
      setConsentStatus('granted');
    } else if (savedConsent === 'denied') {
      setConsentStatus('denied');
    } else {
      // Show modal after a short delay to not interrupt page load
      const timer = setTimeout(() => {
        setShowModal(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleConsent = (granted: boolean, rememberChoice: boolean) => {
    const status = granted ? 'granted' : 'denied';
    setConsentStatus(status);
    
    if (rememberChoice) {
      localStorage.setItem('location_consent', status);
    } else {
      // Store as session-only (will be asked again on next visit)
      sessionStorage.setItem('location_consent_session', status);
    }
    
    setShowModal(false);
  };

  const LocationConsentComponent = () => (
    <LocationConsentModal 
      open={showModal} 
      onConsent={handleConsent}
    />
  );

  return {
    consentStatus,
    showConsentModal: showModal,
    LocationConsentModal: LocationConsentComponent,
  };
};
